module.exports = __webpack_public_path__ + "static/sfMono-c9d3d1cc6c9e2dc7ed4a4b66b368db43.svg";